<template>
  <div id="sellerList">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="微信昵称">
        <el-input size="mini" placeholder="微信昵称" prefix-icon="el-icon-search" v-model="searchForm.nickName">
        </el-input>
      </el-form-item>
      <el-form-item label="用户姓名">
        <el-input size="mini" placeholder="用户姓名" prefix-icon="el-icon-search" v-model="searchForm.userName">
        </el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input size="mini" placeholder="手机号" prefix-icon="el-icon-search" v-model="searchForm.phone">
        </el-input>
      </el-form-item>
      <el-form-item label="地区筛选">
        <el-cascader size="mini" v-model="searchForm.provinceAndCity" :options="provinceAndCityOption"></el-cascader>
      </el-form-item>
      <el-form-item label="用户等级">
        <el-select style="width: 100px" size="mini" v-model="searchForm.levelName" placeholder="请选择">
          <el-option v-for="item in creditLevelList" :key="item.id" :label="item.levelName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册时间">
        <el-date-picker style="width: 250px" size="mini" v-model="searchForm.times" type="daterange"
          value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注">
        <el-input size="mini" placeholder="请输入备注" prefix-icon="el-icon-search" v-model="searchForm.notes">
        </el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords"
        >
        </el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button size="mini" @click="exportToExcel">导出</el-button>
      </el-form-item>
    </el-form>
    <common-table ref="ctable" :searchForm="searchForm" :api="table.api" :rowAction="table.rowAction"
      :batchAction="table.batchAction" :column="table.column" :callback="table.callback">
      <template slot-scope="scope">
        <el-button @click.native.prevent="blackListOperate(scope.rowData)" type="text" size="small">
          {{ scope.rowData.black ? "移除黑名单" : "加入黑名单" }}
        </el-button>
        <el-button @click.native.prevent="viewSeller(scope.rowData)" type="text" size="small">
          查看
        </el-button>
        <el-button @click.native.prevent="deleteSeller(scope.rowData)" type="text" size="small">
          删除
        </el-button>
        <el-button @click.native.prevent="noteSeller(scope.rowData)" type="text" size="small">
          备注
        </el-button>
      </template>
    </common-table>
    <el-dialog title="用户信息" :visible.sync="viewDialogVisible" width="50%">
      <user-detail-layper :key="seller.id" :seller="seller"></user-detail-layper>
    </el-dialog>
    <el-dialog title="用户备注" :visible.sync="showNotes" width="50%">
      <el-input type="textarea" :rows="2" placeholder="请输入内容,30个字符以内" maxlength="30" v-model="notes">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSellerNotes()">取 消</el-button>
        <el-button type="primary" @click="saveSellerNotes">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="站内通知" :visible.sync="showSysNotice" width="50%">
      <el-input placeholder="请输入通知标题" v-model="sysNoticeTitle">
      </el-input>
      <p></p>
      <el-input type="textarea" :rows="2" placeholder="请输入通知内容" v-model="sysNoticeContent">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSysNotice()">取 消</el-button>
        <el-button type="primary" @click="saveSysNotice">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="uploadDialog.visible" width="50%" @open="uploadDialog.fileList = []">
      <el-upload class="upload-demo" action="api/seller/importUserSample" :limit="1" accept=".xlsx"
        :file-list="uploadDialog.fileList" :on-success="uploadDialog.handleSuccess"
        :before-upload="uploadDialog.beforeUpload" :on-error="uploadDialog.handleError">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传xlsx文件
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="uploadDialog.loading" @click="uploadDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- <el-dialog
      title="订单详情"
      width="70%"
      :visible.sync="detailDialog.visible"
      @closed="detailDialog.data = {};detailDialog.fileList=[]"
    >
    <detail :detail="detailDialog"></detail>
    </el-dialog> -->
    <select-group ref="selectGroup"></select-group>
  </div>
</template>

<script>
import { CodeToText, provinceAndCityDataPlus } from "element-china-area-data";
import utils from "../utils/utils";
import axios from "axios";
// import detail from './schedule/order_detail.vue'
import commonTable from "./plugin/common-table.vue";
import userDetailLayper from './layper/user-info-layper.vue'
import selectGroup from "./customer/select-group.vue";
import qs from "qs";
export default {
  components: { commonTable,userDetailLayper,selectGroup },
  name: "seller-list",
  data() {
    return {
      fileList: [],
      uploadDialog: {
        visible: false,
        fileList: [],
        loading: false,
        handleSuccess: () => {
          this.uploadDialog.loading = false;
        },
        beforeUpload: () => {
          this.uploadDialog.loading = true;
        },
        handleError: () => {
          this.uploadDialog.loading = false;
        }
      },
      table: {
        api: "api/seller/query",
        callback: (res, data) => {
          data.forEach((item) => {
            item.address = `${item.province || ''}${item.city || ''}${item.county || ''}${item.town || ''}${item.detailAddress || ''}`;
          });
        },
        rowAction: { label: "操作", width: 120, fixed: "right" },
        batchAction: [
          { text: "添加会员", action: this.gotoAdd, type: "primary" },
          { text: "批量导入", action: this.importFromExcel, type: "primary" },
          { text: "移动分组", action: this.moveToGroup, type: "primary" },
          { text: "导出", action: this.exportToExcel },
          { text: "站内通知", action: this.sendSysNotice },
          { text: "样表导出", action: this.exportTemp },
        ],
        column: [
          {
            label: "微信昵称",
            name: "nickname",
            width: 150,
            extend: { name: "headPic", type: "avatar" },
          },
          { label: "姓名", name: "sellerName" },
          { label: "地区", name: "address" },
          { label: "手机号", name: "phone", width: 80 },
          { label: "等级名称", name: "creditLevelName" },
          { label: "信用积分", name: "creditPoint" },
          { label: "钱包余额", name: "a", },
          { label: "消费金额", name: "b" },
          {
            label: "下单权限", name: "orderAuthority", type: "switch", action: (row) => {
              this.$httpRequest.get(`/api/seller/enableOrderAuthority?sellerId=${row.id}&status=${row.orderAuthority == 1 ? 2 : 1}`)
              this.$refs.ctable.getData();
            }
          },
          {
            label: "注册时间",
            name: "registDate",
            formatter: this.dateFormatter,
          },
          { label: "备注", name: "notes" },
        ],
      },
      creditLevelList: [],
      provinceAndCityOption: provinceAndCityDataPlus,
      searchForm: {
        levelName: "",
        times: [],
        provinceAndCity: [],
        nickName: "",
        userName: "",
        phone: "",
        notes: "",
      },
      detailDialog: {
        visible: false,
        loading: false,
        data: {},
        formData: [],
        evalData: {}
      },
      tableData: [],
      
      pageInfo: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      viewDialogVisible: false,
      activeName: "first",
      seller: {},
      defaultHeadPicSrc: require("../assets/person.png"),
      multipleSelection: [],
      statusObj: [
        { status: "0", name: "全部", showTab: true },
        { status: "4", name: "待支付", showTab: false },
        { status: "10", name: "已退款", showTab: true },
        { status: "6", name: "已完成", showTab: true },
      ],
      notes: "",
      showNotes: false,
      sellerId: null,
      showSysNotice: false,
      sysNoticeTitle: "",
      sysNoticeContent: "",
    };
  },
  created() {
    this.queryLevelAll();
  },
  methods: {
    gotoAdd() {
      this.$router.push("/add-seller");
    },
    importFromExcel() {
      this.uploadDialog.visible = true;
    },
    //获取用户信用等级
    queryLevelAll() {
      utils.axiosMethods({
        method: "GET",
        url: "/api/creditManage/queryLevelAll",
        callback: (res) => {
          this.creditLevelList = res.data.list;
        },
      });
    },
    //查询
    onSearch() {
      if (this.searchForm.times && this.searchForm.times.length > 0) {
        this.searchForm.registerStart = this.searchForm.times[0];
        this.searchForm.registerEnd = this.searchForm.times[1];
      }
      if (
        this.searchForm.provinceAndCity &&
        this.searchForm.provinceAndCity.length > 0
      ) {
        this.searchForm.province = this.searchForm.provinceAndCity[0];
        this.searchForm.city = this.searchForm.provinceAndCity[1];
      }
      this.$refs.ctable.getData();
    },
    // kangfuTabelCellClick(row, column, cell, event){
    //   if(column.property == 'orderNum'){
    //     this.showDetail(row);
    //   }
    // },
    showDetail(data) {
      this.detailDialog.visible = true;
      this.detailDialog.loading = true;
      this.$httpRequest.get('api/serviceOrder/getRelatedFormList', { orderId: data.id, pageSize: 1000, currentPage: 1 }).then(res => {
        this.detailDialog.formData = res.data.list;
      })

      let orderStu = {
        '0': '待派单',
        '1': '已派单',
        '2': '上门中',
        '3': '服务中',
        '4': '已完成',
        '5': '已取消',
        '6': '退单审核中',
        '10': '待支付',
        '11': '退款中',
        '12': '已退款',
      }
      this.$httpRequest
        .get("api/serviceOrder/getOrderDetail?orderId=" + data.id)
        .then((res) => {
          this.detailDialog.data = res.data.obj;
          this.detailDialog.data.status = orderStu[res.data.obj.status];
          this.detailDialog.fileList = [];
          if (res.data.obj.orderData) {
            res.data.obj.orderData.split(';').forEach(od => {
              const index = od.lastIndexOf('/') + 1
              this.detailDialog.fileList.push({
                name: od.substring(index),
                url: od
              })
            })
          }
          this.$httpRequest.get("api/serviceOrder/getOrderEval?orderId=" + data.id).then(res => {
            if (res.data.list && res.data.list.length > 0) {
              this.detailDialog.evalData = res.data.list;
              this.detailDialog.evalData.forEach(item => {
                item.isShow = item.isShow == '1'
                if (item.imgUrls) {
                  item.imgUrls = item.imgUrls.split(',')
                }
                item.createTime = util.dateFormat(item.createTime, "yyyy-MM-dd HH:mm")
              })
              var t = this.detailDialog.evalData.filter(x => x.sellerId)
              if (t && t.length > 0) {
                this.detailDialog.lastEval = t[t.length - 1];
              }
            }
          })
          this.detailDialog.loading = false;
        })
        .catch((e) => (this.detailDialog.loading = false));
    },
    handleSuccess(response, file, fileList) {
      const i = response.lastIndexOf('/') + 1
      file.name = response.substring(i);
      let orderData = `${this.detailDialog.data.orderData};${response}`;
      if (!this.detailDialog.data.orderData) {
        orderData = response;
      }
      this.$httpRequest
        .post("api/serviceOrder/commitOrderData", { orderId: this.detailDialog.data.id, orderData: orderData })
        .then((res) => {
          this.$message.success('上传成功')
        }).catch(() => {
          this.$message.error('上传失败')
          const index = fileList.indexOf(file);
          fileList.splice(index, 1)
        })
    },
    removeInServer(file, fileList) {
      const orderData = fileList.filter(f => f != file).map(f => f.url).join(';')
      this.$httpRequest
        .post("api/serviceOrder/commitOrderData", { orderId: this.detailDialog.data.id, orderData: `${orderData}` })
        .then((res) => {
          this.$message.success('删除成功')
          this.detailDialog.data.orderData = orderData;
          const index = fileList.indexOf(file);
          fileList.splice(index, 1)
        }).catch(() => {
        })
      return false;
    },

    submitRemark() {
      this.$message.error('缺少提交备注接口')
    },

    downloadFile(file) {
      console.log(file)
      window.open(
        file.url,
        "_brank"
      );
    },
    exportTemp() {
      window.open(
        "http://pic.mumetech.com/1655624792862_附件1.1用户批量导入表V2-zxl20220617.xlsx",
        "_parent"
      );
    },
    //导出
    exportToExcel() {
      const exportData = this.$refs.ctable.getMultipleSelection();
      window.open(
        "/api/seller/exportToExcel?ids=" +
        exportData.map((s) => s.id).join(","),
        "_parent"
      );
    },
    moveToGroup(){
      const exportData = this.$refs.ctable.getMultipleSelection();
      if(!exportData || exportData.length==0){
        this.$message.info("请选择要移动的用户")
        return
      }
      this.$refs.selectGroup.open(exportData)
    },
    //查看
    viewSeller(row) {
      this.sellerId = row.id;
      this.seller = Object.assign({}, row);
      this.viewDialogVisible = true;
      return
      
      this.orderInfo.params.sellerId = row.id
      this.walletList.params.sellerId = row.id
      this.vipPayMounthTableData.params.sellerId = row.id
      this.creditInfo.params.id = row.id
      this.vipPayTableData.params.sellerName = row.nickname
      this.vipPayTableData.params.sellerId = row.id
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0)",
      });
      if (this.seller.userDefSetting) {
        const kangfu = JSON.parse(this.seller.userDefSetting)
        const keys = Object.keys(kangfu)
        const rows = Math.ceil(keys.length / 2)
        this.seller.kangfu = []
        for (let r = 0; r < rows; r++) {
          let key1 = keys[(2 * r)], key2 = keys[(2 * r + 1)]
          this.seller.kangfu[r] = [key1, kangfu[key1], key2, kangfu[key2]]
        }
      }

      this.activeName = "first"
      utils.axiosMethods({
        method: "GET",
        url: "/api/seller/getSellerPayLimit",
        params: {
          sellerId: row.id,
        },
        callback: (res) => {
          loading.close();
          this.viewDialogVisible = true;
          this.payLimit = res.data.obj;
        },
        catch: (err) => {
          loading.close();
        },
      });

      // this.$httpRequest
      //   .post(
      //     "/api/order/queryArticleOrder?" +
      //     qs.stringify({ currentPage: 1, pageSize: 500 }),
      //     { sellerName: row.nickname }
      //   )
      //   .then((res) => {
      //     this.vipPayTableData = res.data.list.map((element, index) => {
      //       element.index = index + 1;
      //       element.statusName = element.status;
      //       element.createTime = utils.dateFormat(
      //         element.createTime,
      //         "yyyy-MM-dd HH:mm:ss"
      //       );
      //       this.statusObj.forEach((item) => {
      //         if (item.status == element.status && element.status != 0) {
      //           element.statusName = item.name;
      //         }
      //       });
      //       return element;
      //     });
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   });

      // this.$httpRequest
      //   .post(
      //     "/api/order/queryOrder?" +
      //     qs.stringify({ currentPage: 1, pageSize: 500 }),
      //     { searchType: "order", keyWord: row.nickname }
      //   )
      //   .then((res) => {
      //     this.vipPayMounthTableData = res.data.list.map((element, index) => {
      //       element.index = index + 1;
      //       element.statusName = element.status;
      //       this.statusObj.forEach((item) => {
      //         if (item.status == element.status && element.status != 0) {
      //           element.statusName = item.name;
      //         }
      //       });
      //       return element;
      //     });
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   });
      let orderStu = {
        '0': '待派单',
        '1': '已派单',
        '2': '上门中',
        '3': '服务中',
        '4': '已完成',
        '5': '已取消',
        '6': '退单审核中',
        '10': '待支付',
        '11': '退款中',
        '12': '已退款',
      }
      // this.$httpRequest
      // .get(
      //   "/api/serviceOrder/getNursingOrderByUserId?" +
      //     qs.stringify({ currentPage: 1, pageSize: 500,userId:row.id })
      // )
      // .then((res) => {
      //   this.kangfuTableTotal = res.data.obj;
      //   this.kangfuTableData = res.data.list.map((element, index) => {
      //     element.index = index + 1;
      //     element.statusName = orderStu[element.status];
      //     element.appointTime = utils.dateFormat(
      //       element.appointTime,
      //       "yyyy-MM-dd HH:mm:ss"
      //     );
      //     return element;
      //   });
      // })
      // .catch((e) => {
      //   console.log(e);
      // });
    },
    //删除
    deleteSeller(row) {
      utils.axiosMethods({
        method: "POST",
        url: "/api/seller/deleteById",
        params: {
          id: row.id,
        },
        callback: (res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "恭喜你，删除成功",
              type: "success",
            });
            this.onSearch();
          }
        },
      });
    },
    //每页展示数据条数改变
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.onSearch();
    },
    //页码改变
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.onSearch();
    },
    // 省市显示中文
    codeToText(str) {
      return str != null && str != "" ? CodeToText[str] : "";
    },
    noteSeller(row) {
      this.notes = row.notes;
      this.showNotes = true;
      this.sellerId = row.id;
    },
    saveSellerNotes() {
      this.$httpRequest.post("/api/seller/updateSellerNotes",{
          id: this.sellerId,
          notes: this.notes,
        }).then(res=>{
          this.showNotes = false;
          this.onSearch();
          this.$message({
            message: "恭喜你，修改成功",
            type: "success",
          });
        })
    },
    closeSellerNotes() {
      this.showNotes = false;
      this.sellerId = null;
    },
    blackListOperate(row) {
      if (row.black) {
        utils.axiosMethods({
          method: "GET",
          url: "/api/seller/removerFromBlackList",
          params: {
            id: row.id,
          },
          callback: (res) => {
            this.onSearch();
            this.$message({
              message: "移除黑名单成功",
              type: "success",
            });
          },
        });
      } else {
        utils.axiosMethods({
          method: "GET",
          url: "/api/seller/joinToBlackList",
          params: {
            id: row.id,
            name: row.name,
          },
          callback: (res) => {
            this.onSearch();
            this.$message({
              message: "加入黑名单成功",
              type: "success",
            });
          },
        });
      }
    },
    closeSysNotice() {
      this.showSysNotice = false;
    },
    sendSysNotice() {
      this.$refs.ctable.getMultipleSelection();
      this.showSendSysNoticeWin();
    },
    showSendSysNoticeWin() {
      this.showSysNotice = true;
    },
    saveSysNotice() {
      const data = this.$refs.ctable.getMultipleSelection();
      utils.axiosMethods({
        method: "POST",
        url: "/api/seller/sendSysNotice",
        data: {
          ids: data.map((s) => s.id).join(","),
          title: this.sysNoticeTitle,
          content: this.sysNoticeContent,
        },
        callback: (res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "发送成功",
              type: "success",
            });
            this.showSysNotice = false;
          } else {
            this.$message.error(res.data.msg);
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
#sellerList {
  .block {
    float: right;
    margin-top: 20px;
  }

  .el-tabs__content .el-row {
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sellerList.vue